import {gql} from 'apollo-angular';


export default gql`
mutation FinishUserInvite($input: FinishInviteInput!) {
  finishUserInvite(input: $input)
}
`;
